import {  mediaContents } from "../../constants/apiUrl";
import { IApiResponse } from "../../models/IAPIResponse";
import APIService from "../../helper/api-service";
import { urlBinder } from "../../helper/url-binder";
import { IMediaContentData, IMediaContents } from "../../models/master/mediaContent";

 export default new (class MediaContentService {
  public getMediaContent = async (
    id: number
  ): Promise<IApiResponse<IMediaContentData>> => {
    try {
      let endPoint = urlBinder(mediaContents.GET_MEDIA_CONTENT, [`${id}`]);
      const response = await APIService.get(endPoint);
      return response.data as IApiResponse<IMediaContentData>;
    } catch (error: any) {
      if (error.response) {
        return error.response as IApiResponse<IMediaContentData>;
      } else {
        throw error;
      }
    }
  };

  public getMediaContents = async (
    configUserType?:number
  ): Promise<IApiResponse<Array<IMediaContents>>> => {
    try {
      let endPoint = urlBinder(mediaContents.GET_ALL_MEDIA_CONTENTS, [configUserType]);
      const response = await APIService.get(endPoint);
      return response.data as IApiResponse<Array<IMediaContents>>;
    } catch (error: any) {
      if (error.response) {
        return error.response as IApiResponse<Array<IMediaContents>>;
      } else {
        throw error;
      }
    }
  };

  public createMediaContent = async (
    data: any
  ): Promise<IApiResponse<boolean|any>> => {
    try {
      let endPoint = mediaContents.CREATE_MEDIA_CONTENT;
      const response = await APIService.postFormData(endPoint, data);
      return response.data as IApiResponse<boolean|any>;
    } catch (error: any) {
      if (error.response) {
        return error.response as IApiResponse<boolean|any>;
      } else {
        throw error;
      }
    }
  };

  public updateMediaContent = async (
    data: any,id:number
  ): Promise<IApiResponse<boolean>> => {
    try {
      let endPoint = urlBinder(mediaContents.UPDATE_MEDIA_CONTENT, [`${id}`]);
      const response = await APIService.put(endPoint, data);
      return response.data as IApiResponse<boolean>;
    } catch (error: any) {
      if (error.response) {
        return error.response as IApiResponse<boolean>;
      } else {
        throw error;
      }
    }
  };

  public updateMediaContentPriority = async (
    data: any
  ): Promise<IApiResponse<boolean>> => {
    try {
      let endPoint = mediaContents.UPDATE_MEDIA_CONTENT_PRIORITY;
      const response = await APIService.put(endPoint, data);
      return response.data as IApiResponse<boolean>;
    } catch (error: any) {
      if (error.response) {
        return error.response as IApiResponse<boolean>;
      } else {
        throw error;
      }
    }
  };
  
  public deleteMediaContent = async (id: number): Promise<boolean> => {
    try {
      let endPoint = urlBinder(mediaContents.DELETE_MEDIA_CONTENT, [`${id}`]);
      const response = await APIService.delete(endPoint);
      return response.status === 204 ? true : false;
    } catch (error: any) {
      if (error.response) {
        return false as boolean;
      } else {
        throw error;
      }
    }
  };
})();
